export enum Position {
  BOTTOM_LEFT = "bottom-left",
  BOTTOM_RIGHT = "bottom-right",
  BOTTOM_MIDDLE = "bottom-middle",
  TOP_LEFT = "top-left",
  TOP_RIGHT = "top-right",
}

export default Position;
